import { StepType, useTour } from '@reactour/tour';
import { useProvider } from 'utils/providers/Provider';
import Content from 'ui/components/common/Tour/Content';

import { TOUR_SELECTOR } from '..';

const useGetHowToCreateInvoice = () => {
  const { dispatch, state } = useProvider();
  const { setIsOpen, setSteps, setCurrentStep } = useTour();
  const isCollapsed = state?.collapse;
  const { TOUR } = TOUR_SELECTOR;

  const createInvoiceSteps: StepType[] = [
    {
      content: 'Go to the Sales menu tab',
      selector: `[data-tut="${TOUR.SALES.MENU}"]`,
      position: 'right',
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 500);
          },
          false,
        );
      },
      styles: {
        arrow: (base) => ({
          ...base,
          visibility: 'hidden',
        }),
        popover: (base) => ({ ...base, marginTop: 29 }),
      },
    },
    {
      content: 'Then select Invoice to view the Invoice page',
      position: 'right',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.SUBMENU}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 500);
          },
          false,
        );
      },
      styles: {
        arrow: (base) => ({
          ...base,
        }),
        popover: (base) => ({ ...base, marginTop: 23 }),
      },
    },
    {
      content: 'On the Invoice page, click on the Create Invoice button',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.FORM.CREATE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(3), 200);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          type="Create Invoice"
          // eslint-disable-next-line max-len
          content="Fill in the invoice details like the contact the invoice will be billed to, items, amount, date issued, date due, and any necessary file attachments."
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.FORM.FORM}"]`,
      stepInteraction: false,
      padding: 22,
      styles: {
        popover: (base) => ({ ...base, maxWidth: 600 }),
      },
      position: 'top',
    },
    {
      content: 'Click Preview Draft to see how the invoice will show when sent',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.PREVIEW.DRAFT_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(5), 200);
          },
          false,
        );
      },
    },
    {
      content: (props) => (
        <Content
          content="This modal shows you a preview of your created invoice."
          {...props}
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.PREVIEW.DRAFT_MODAL}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(6), 200);
          },
          false,
        );
      },
      padding: 22,
      position: 'left',
    },
    {
      content: 'Click Close',
      selector: `[data-tut="${TOUR.MODAL_CLOSE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(7), 200);
          },
          false,
        );
      },
      padding: 22,
    },
    {
      content: 'Click Save & Continue and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.INVOICE.FORM.SAVE_BUTTON}"]`,
      action: (node) => {
        node?.addEventListener(
          'click',
          function () {
            setIsOpen(false);
            setTimeout(() => {
              window.location.href = '/';
            }, 300);
          },
          false,
        );
      },
    },
  ];

  const showCreateInvoiceSteps = () => {
    if (isCollapsed) {
      dispatch?.({ type: 'toggleSidebar' });
    }

    setTimeout(() => {
      setSteps?.(createInvoiceSteps);
      setIsOpen(true);
    }, 300);
  };

  return showCreateInvoiceSteps;
};

export default useGetHowToCreateInvoice;
